module.exports = __webpack_public_path__ + "static/media/sploosh.1e61fa55.mp3";